import { GiHamburgerMenu } from 'react-icons/gi';
import React from 'react';

export interface MobileMenuButtonProps {
  onClick?: () => void;
}

export function MobileMenuButton({ onClick }: MobileMenuButtonProps) {
  return (
    <button className="menu-btn only-mobile" type="button" onClick={onClick}>
      <GiHamburgerMenu size={25} color="black" />
    </button>
  );
}

export function useMobileMenu() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const openMenu = () => {
    setIsMenuOpen(true);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return {
    isMenuOpen,
    openMenu,
    closeMenu,
  };
}
